import { jsx } from "react/jsx-runtime";
import GridViewIcon from "@mui/icons-material/GridView";
import { validateTidalLicense } from "../../base/index.js";
function GridView(props) {
  return /* @__PURE__ */ jsx(
    GridViewIcon,
    {
      "data-testid": "GridView",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "GridView",
      "data-tidal-icon-meta": "layout"
    }
  );
}
GridView.tidalIconMeta = {
  categories: "layout",
  name: "GridView"
};
validateTidalLicense();
export {
  GridView
};
//# sourceMappingURL=GridView.js.map
